import styled from 'styled-components';

export const TrainersListCards = styled.div``;

export const TrainerCard = styled.div``;

export const TrainersListCardsHeader = styled.div`
  margin-bottom: 30px;
`;
